const styles = theme => ({
  tooltipHelp: {
    marginLeft: theme.spacing(1) / 2,
  },
  tooltipWidth: {
    maxWidth: '510px',
  },
})

export default styles
